import React from 'react';

const Logo = ({ className = "w-8 h-8", themeColor = "#00E5FF" }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" fill="none" className={className}>
    <rect x="6" y="6" width="36" height="36" fill="#0A0B0E" stroke="currentColor" strokeWidth="3" />
    <path d="M14 18 L22 24 L14 30" stroke={themeColor} strokeWidth="4" strokeLinecap="square" strokeLinejoin="miter" />
    <rect x="26" y="28" width="8" height="4" fill="currentColor" />
    <rect x="6" y="6" width="36" height="8" fill="currentColor" />
    <circle cx="12" cy="10" r="2" fill="#0A0B0E" />
  </svg>
);

export default Logo;
